import React from "react";
import { Typography } from "antd";
import dayjs from "dayjs";
import { capitalizeFirstLetter } from "../../../helpers/auth/helper";
import styles from "./EditAppointmentModal.module.css";

const AppointmentPatientSummary = ({ editData, patientDetails }) => {
  const firstName =
    editData?.patient_first_name || patientDetails?.first_name || "";
  const lastName =
    editData?.patient_last_name || patientDetails?.last_name || "";
  const fullName = `${
    firstName ? capitalizeFirstLetter(firstName) : ""
  } ${lastName ? capitalizeFirstLetter(lastName) : ""}`.trim();

  const dob = patientDetails?.dob ? dayjs(patientDetails.dob) : null;
  const age = editData?.patient_age ?? patientDetails?.age_by_dob;

  const rows = [
    { label: "Name", value: fullName || "—" },
    {
      label: "Mobile",
      value: editData?.patient_mobile || patientDetails?.mobile || "—",
    },
    { label: "Date of birth", value: dob ? dob.format("DD MMM, YYYY") : "—" },
    { label: "Age", value: age ?? "—" },
    {
      label: "Gender",
      value: editData?.patient_gender || patientDetails?.gender || "—",
    },
    { label: "Email", value: patientDetails?.email || "—" },
    { label: "Address", value: patientDetails?.address || "—" },
  ];

  return (
    <div className={styles.patientSummary}>
      <Typography className={styles.patientSummaryTitle}>
        Patient details
      </Typography>
      <div className={styles.patientSummaryGrid}>
        {rows.map((row) => (
          <div className={styles.patientSummaryRow} key={row.label}>
            <span className={styles.patientSummaryLabel}>{row.label}</span>
            <span className={styles.patientSummaryValue}>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentPatientSummary;
